<template>
  <v-dialog v-model="dialog" max-width="500px">
    <v-card>
      <v-toolbar dense>
        <v-toolbar-title aria-level="1" role="heading">{{ toolbarTitle }}</v-toolbar-title>
      </v-toolbar>

      <v-card-text class="text-center body-2 pa-5">
        <div v-if="!message && parseFloat(priceAdjustment).toFixed(2) > 0 && $route.name === 'ChargeCard'">
          <div class="text-center">
          <h2 class="title font-weight-bold mb-1">Sub Total: </h2>
          <p class="subheading secondary--text text--darken-4">
            ${{ parseFloat(amount).toFixed(2) }}
          </p>
          </div>
          <div class="mx-auto">
            <h2 class="title font-weight-bold mb-1">Price Adjustment Fee: </h2>
            <p class="subheading secondary--text text--darken-4">
                ${{ parseFloat(priceAdjustment).toFixed(2) }}
            </p>
          </div>
          <div class="mx-auto">
            <h2 class="title font-weight-bold mb-1">Total: </h2>
            <p class="subheading secondary--text text--darken-4">
                ${{ parseFloat(total).toFixed(2) }}
            </p>
          </div>
        </div>

        <v-alert
          :value="true"
          class="primary lighten-5 text--primary darken-5 mt-5"
          outline
        >
          <p class="headline py-2 mb-0">
            <strong v-if="message">{{ message }}</strong>
            <strong v-else>Do you wish to process this <span class="text-lowercase">{{ title }}</span><span v-if="title !== 'tokenization'"> for {{ formatDollarAmount(total) }}</span>?</strong>
          </p>
        </v-alert>
      </v-card-text>

      <v-card-actions class="d-flex justify-center">
        <v-btn class="ma-3" color="primary" outline text @click="cancel">Cancel</v-btn>
        <v-btn class="ma-3" color="primary" text @click="confirm">Confirm</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    amount: {
      type: [Number, String],
      required: false,
      default: 0
    },
    message: {
      type: String,
      required: false,
      default: ''
    },
    priceAdjustment: {
      type: [Number, String],
      required: false,
      default: 0
    },
    title: {
      type: String,
      required: false,
      default: 'transaction'
    },
    total: {
      type: [Number, String],
      required: false,
      default: 0
    },
    value: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    dialog: {
      get () {
        return this.value
      },
      set (value) {
        this.$emit('input', value)
      }
    },
    toolbarTitle () {
      return this.message ? this.title : `Confirm ${this.title}`
    }
  },
  methods: {
    confirm () {
      this.$emit('confirmed')
      this.dialog = false
    },
    cancel () {
      this.dialog = false
    },
    formatDollarAmount (amount) {
      let numberAmount = parseFloat(amount)

      if (isNaN(numberAmount)) {
        throw new Error('Invalid amount provided')
      }

      return `$${numberAmount.toFixed(2)}`
    }
  }
}
</script>

<style>
.text-center {
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/ConfirmModal.vue